import dayjs from 'dayjs';
export function calculateProductionTime(startTime, endTime, cycleTime, cavity, downTime) {
  const start = dayjs(`2000-01-01T${startTime}`);
  const end = dayjs(`2000-01-01T${endTime}`);

  if (!start.isValid() || !end.isValid()) {
    return 0;
  }

  const numCycleTime = Number(cycleTime);
  const numCavity = Number(cavity);
  const numDownTime = Number(downTime);

  if (isNaN(numCycleTime) || numCycleTime <= 0) {
    return 0;
  }
  if (isNaN(numCavity) || numCavity <= 0) {
    return 0;
  }
  if (isNaN(numDownTime) || numDownTime < 0) {
    return 0;
  }

  let totalShiftMinutes = end.diff(start, 'minute', true);
  if (totalShiftMinutes < 0) {
    totalShiftMinutes += 24 * 60;
  }

  const effectiveProductionMinutes = totalShiftMinutes - numDownTime;

  if (effectiveProductionMinutes <= 0) {
    return 0;
  }

  const countCycle = (effectiveProductionMinutes * 60) / numCycleTime;
  const cavityCount = countCycle * numCavity;

  return Math.round(cavityCount);
}

export const calcualteShiftMinutes=(startTime, endTime) =>{
  const start = dayjs(`2000-01-01T${startTime}`);
  const end = dayjs(`2000-01-01T${endTime}`);
   const totalShiftMinutes = end.diff(start, 'minute', true);
  const actualTotalShiftMinutes = totalShiftMinutes < 0 ? totalShiftMinutes + 24 * 60 : totalShiftMinutes;
  if (!start.isValid() || !end.isValid()) {
    return { value: null, error: "Invalid startTime or endTime format. Please use 'HH:mm:ss'." };
  }
  return actualTotalShiftMinutes
} 